<template>
  <main><PreviousContestBlock v-bind="messages.previous" /></main>
</template>

<script>
import { Head } from '~/mixins/Head'
import { PageMixin } from '~/mixins/PageMixin'
import PreviousContestBlock from '~/components/PreviousContestBlock'

export default {
  mixins: [PageMixin, Head],
  components: {
    PreviousContestBlock
  },
  computed: {
    metaObj() {
      return this.messages.previous.meta
    }
  }
}
</script>



// WEBPACK FOOTER //
// pages/previous.vue